/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedBusinessAngelListDto } from '../../models/backend-paginated-business-angel-list-dto';

export interface VentureFundsBusinessAngelsList$Params {
  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export function ventureFundsBusinessAngelsList(
  http: HttpClient,
  rootUrl: string,
  params?: VentureFundsBusinessAngelsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedBusinessAngelListDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelsList.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedBusinessAngelListDto>;
    }),
  );
}

ventureFundsBusinessAngelsList.PATH = '/api/venture_funds/business-angels/';
